import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import { createBrowserHistory } from 'history';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Debriefing from "./containers/DebriefingForm";    // test route
import Debrief from "./containers/DebriefTable";
import IndexReducer from "./index-reducer";
import IndexSaga from "./index-sagas";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";

import AssessmentQuestion from "./containers/assessmentQuestion";
import ModalLinkedin from './components/addLinkedinJobs'
import AddAssessmentQuestion from "./containers/addAssessmentQuestion";
import AssessmentTest from "./containers/assessmentTest";
import AddAssessmentTest from "./containers/addAssessmentTest";
import LinkedinJobs from "./containers/linkedinJobs";
import Contest from './containers/contest';
import Articles from './containers/articles';
import AddContest from './containers/addContest';
import ContestDetails from './containers/contestDetails';
import CandidateRequest from "./containers/candidateRequest";
import UploadShortlist from "./containers/candidateRequest/uploadShortlist";
import ConfirmCandidates from "./containers/confirmCandidates"
import ImportAssessmentQuestion from "./containers/ImportAssessmentQuestion";
import AddRocketSeries from "./containers/training/addRocketSeries";
import EditRocketSeries from "./containers/training/editRocketSeries";
import TrainingList from "./containers/training";
import AddTraining from "./containers/training/add";
import EditTraining from "./containers/training/update";
import Login from "./containers/login";
import PrivateRoute from "./components/privateRoute";
import CoffeeePlus from "./containers/CoffeeePlus";
import Funnel from "./containers/CoffeeePlus/funnel";
import Groups from "./containers/Groups/Groups"
import CLM from "./containers/CLM";
import Parser from "./components/Parser";
import CandidateLaterals from "./components/CandidateLaterals";
import PracticeModule from './containers/practiceModule'
import CallerForm from './containers/callerForm'
import ListPracticeTest from "./containers/ListPracticeTest";
import DemandForm from './containers/demandForm'
import ConfirmDemand from "./containers/comfirmDemand";
import ConfirmCall from "./containers/comfirmCall";
import AiMachineInterview from './containers/aiMachineInterview'
import AIInterViewForm from "./components/aiInterviewDetailsForm";
import AiInterViewStatus from "./containers/aiMachineInterview/aiInterviewStatus";
import ThemeTable from "./containers/demandTable";
import CandidatesTable from "./containers/CandidatesTable";
import ProfileTable from "./containers/profileTable";
import ReviewerTable from "./containers/reviewerTable";
import ProfileSentTable from "./containers/profileSentTable";
import InterviewTable from "./containers/InterviewTable";
import CompanyTable from "./containers/companyTable";
import CompanyListing from "./containers/companyListing";
import CompanyLogin from "./containers/companyLogin/companyLogin";
import PdfView from "./components/candidateAssessmentPdf";
import PdfViewAction from "./containers/companyTable/components/candidateAssessment";
import SendOtp from "./containers/companyLogin/companyOTP";
import PerformanceReport from "./containers/PerformanceReport";
import ReviewDashboard from "./containers/ReviewDashboard";
import ClientDashboard from "./containers/ClientDashboard";
import DemandDashboard from "./containers/Demand Dashboard";
import RecruiterManagement from "./containers/RecruiterManagement";
import CoffeeePlusSearch from "./containers/CoffeeePlusSearch";
import BashQuestions from "./containers/bashQuestions";
const sagaMiddleware = createSagaMiddleware();

const composeSetup =
  process.env.NODE_ENV !== "production" &&
    typeof window === "object" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const store = createStore(
  IndexReducer,
  composeSetup(applyMiddleware(sagaMiddleware))
);
sagaMiddleware.run(IndexSaga);

const root = ReactDOM.createRoot(document.getElementById("root"));
const admin_access = localStorage.getItem("admin_access");
root.render(
  <Provider store={store}>
    <BrowserRouter>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_API_KEY}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      <Routes>
        <Route path="/login" element={<Login/>}/>
        <Route path="/" element={<App />}>
          <Route index element={<Navigate to="/login" replace />} />

          <Route path="training/add" element={<PrivateRoute><AddTraining /></PrivateRoute>} />
          <Route path="training/addRocketSeries" element={<PrivateRoute><AddRocketSeries /></PrivateRoute>} />
          <Route path="training/editRocketSeries/:id" element={<PrivateRoute><EditRocketSeries /></PrivateRoute>} />
          <Route path="training/:id" element={<PrivateRoute><EditTraining /></PrivateRoute>} />
          <Route path="training" element={<PrivateRoute><TrainingList /></PrivateRoute>} />


          <Route path="articles/add" element={<PrivateRoute><Articles title="Add" /></PrivateRoute>} />
          <Route path="articles" element={<PrivateRoute><Articles title="List" /></PrivateRoute>} />
          <Route path="articles/:id" element={<PrivateRoute><Articles title="Edit" /></PrivateRoute>} />


          <Route path="assessment-question" element={<PrivateRoute><AssessmentQuestion /></PrivateRoute>} />
          <Route path="assessment-question/add" element={<PrivateRoute><AddAssessmentQuestion /></PrivateRoute>} />
          <Route path="assessment-question/edit/:id" element={<PrivateRoute><AddAssessmentQuestion /></PrivateRoute>} />

          <Route path="assessment-test" element={<PrivateRoute><AssessmentTest /></PrivateRoute>} />
          <Route path="assessment-test/add" element={<PrivateRoute><AddAssessmentTest /></PrivateRoute>} />
          <Route path="assessment-test/edit/:id" element={<PrivateRoute><AddAssessmentTest /></PrivateRoute>} />

          <Route path="assessment-group" element={<PrivateRoute><Groups /></PrivateRoute>} />
          <Route path="assessment-group/add" element={<PrivateRoute><Groups /></PrivateRoute>} />
          <Route path="assessment-group/edit/:id" element={<PrivateRoute><Groups /></PrivateRoute>} />

          <Route path="bash-questions" element={<PrivateRoute><BashQuestions /></PrivateRoute>} />

          <Route path="candidateRequest" element={<PrivateRoute><CandidateRequest /></PrivateRoute>} />
          <Route path="candidateRequest/upload-shortlist" element={<PrivateRoute><UploadShortlist /></PrivateRoute>} />


          <Route path="confirm-candidate/:recruiter_id/:search_id/:role" element={<PrivateRoute><ConfirmCandidates /></PrivateRoute>} />


          <Route path="import-questions" element={<PrivateRoute> <ImportAssessmentQuestion /></PrivateRoute>} />

          <Route path="coffeee-plus" element={<PrivateRoute><CoffeeePlus /></PrivateRoute>} />
          <Route path="coffeee-plus/edit/:funnelId" element={<PrivateRoute><Funnel mode="edit" /></PrivateRoute>} />
          <Route path="coffeee-plus/new" element={<PrivateRoute><Funnel mode="new" /></PrivateRoute>} />

          <Route path="coffeee-plus-Search" element={<PrivateRoute><CoffeeePlusSearch /></PrivateRoute>} />
          <Route path="coffeee-plus-search" element={<Navigate to="/coffeee-plus-Search" replace />} />

          <Route path="contest-plus" element={<PrivateRoute><Contest /></PrivateRoute>} />
          <Route path="contest-plus/edit/:funnelId" element={<PrivateRoute><Funnel mode="edit" /></PrivateRoute>} />
          <Route path="contest-plus/new" element={<PrivateRoute><Funnel mode="new" /></PrivateRoute>} />
          <Route path="contest-plus/details/:funnelId" element={<PrivateRoute><ContestDetails /></PrivateRoute>} />

          {admin_access == 0 && <Route path="coffeee-clm" element={<PrivateRoute><CLM /></PrivateRoute>} />}
          <Route path="update-user-details" element={<PrivateRoute><Parser/></PrivateRoute>}/>
          <Route path="candidate-laterals" element={<PrivateRoute><CandidateLaterals/></PrivateRoute>}/>

          <Route path="practice-assessment-test/add" element={<PrivateRoute><PracticeModule /></PrivateRoute>} />
          <Route path="practice-assessment-test/edit/:id" element={<PrivateRoute><PracticeModule /></PrivateRoute>} />

          <Route path="practice-assessment-test" element={<PrivateRoute><ListPracticeTest /></PrivateRoute>} />

          <Route path="submission-form" element={<PrivateRoute><CallerForm /></PrivateRoute>} />
          <Route path="demand-form" element={<PrivateRoute><DemandForm /></PrivateRoute>} />
          <Route path="confirm-demand" element={<PrivateRoute><ConfirmDemand /></PrivateRoute>} />
          <Route path="confirm-call" element={<PrivateRoute><ConfirmCall /></PrivateRoute>} />
          <Route path="/easyapply/get-all" element={<PrivateRoute><LinkedinJobs/></PrivateRoute>}/>
          <Route path="/easyapply/add" element={<PrivateRoute><ModalLinkedin /></PrivateRoute>} />
          <Route path="/machine-interview" element={<PrivateRoute><AiMachineInterview/></PrivateRoute>}></Route>
          <Route path="/ai-interview-form" element={<PrivateRoute><AIInterViewForm /></PrivateRoute>}>  </Route>
          <Route path="/ai-interview-status" element={<PrivateRoute><AiInterViewStatus /></PrivateRoute>}>  </Route>

          <Route path="demand-table" element={<PrivateRoute><ThemeTable/></PrivateRoute>}/>
          <Route path="candidate-table" element={<PrivateRoute><CandidatesTable/></PrivateRoute>}/>
          <Route path="profile-table" element={<PrivateRoute><ProfileTable/></PrivateRoute>}/>
          <Route path="reviewer-table" element={<PrivateRoute><ReviewerTable/></PrivateRoute>}/>
          <Route path="profile-sent-table" element={<PrivateRoute><ProfileSentTable/></PrivateRoute>}/>
          <Route path="interview-table"element={<PrivateRoute><InterviewTable /></PrivateRoute>}/>
          <Route path="performance-report" element={<PrivateRoute><PerformanceReport/></PrivateRoute>}/>
          <Route path="review-dashboard" element={<PrivateRoute><ReviewDashboard/></PrivateRoute>}/>
          <Route path="client-dashboard" element={<PrivateRoute><ClientDashboard/></PrivateRoute>}/>

          <Route path="debriefing-form" element={<PrivateRoute><Debriefing/></PrivateRoute>}/>
          <Route path="debrief-table" element={<PrivateRoute><Debrief/></PrivateRoute>}/>
          <Route path="demand-dashboard" element={<PrivateRoute><DemandDashboard/></PrivateRoute>}/>
          <Route path="recruiter-management" element={<PrivateRoute><RecruiterManagement/></PrivateRoute>}/>


        </Route>
        <Route path="company-login" element={<CompanyLogin/>}/>
        <Route path="company-table" element={<CompanyTable/>}/>
        <Route path="company-listing" element={<CompanyListing/>}/>
        <Route path="provide-otp" element={<SendOtp/>}/>

      </Routes>
      <ToastContainer />
      </GoogleOAuthProvider>
    </BrowserRouter>
  </Provider>

);